/**
 * Games Info Favorites Category Model
 */

define(function(require, exports, module) {
    'use strict';

    var _ = require('underscore');
    var user = require('user');
    var favoritesStore = require('stores/favorites/favorites.store.instance');
    var CategoryModel = require('portlets/games-info/categories/gamesinfo.category.model');
    var GamesInfoGameCollection = require('portlets/games-info/gamesinfo.game.collection');

    module.exports = CategoryModel.extend({
        defaults: {
            isLoading: favoritesStore.get('state') === 'pending',
            dynamic: true,
            isShowGamesWhileLoading: true
        },

        initialize: function() {
            CategoryModel.prototype.initialize.apply(this, arguments);

            if (user.isLoggedIn()) {
                favoritesStore.fetch().done(function() {
                    favoritesStore.state.forEach(function(favorite) {
                        if (GamesInfoGameCollection.filterGames([favorite.favoriteID]).length) {
                            this._update(favorite.favoriteID);
                        }
                    }, this);
                    this.set('isLoading', false);

                    this.listenTo(favoritesStore, 'add remove', function(favoriteModel) {
                        this._update(favoriteModel.get('favoriteID'));
                    }, this);

                }.bind(this));
            }
        },

        _update: function(id) {
            var games = _.clone(this.get('games'));
            var gameIndex = games.indexOf(id);

            gameIndex === -1
                ? games.unshift(id)
                : games.splice(gameIndex, 1);

            this.set('games', games);
        }

    });
});
